<template>
<div>
  
  <div id="first" class="justify-content-center" style="margin-top:0;" >
    <div class="col-xs-zero col-xl-4 ">
    </div>
    <div class="col-xs-12 col-xl-3 " style="background-color:white; padding: 0% ; border-radius: 15px 15px 15px 15px; margin: 0 auto;" >
        <transition name="fade">
          <div id="0" @click="tabClicked" v-show="this.level >= 0" class="alert alert-danger first-header-tab" 
            v-bind:style="{ 'background-color': customizeData.ColorHex, 'color': customizeData.HeadColor }">
              {{ this.customizeData.HeadService }}
          </div>
        </transition>
        <transition name="fade">
          <div id="1" @click="tabClicked" v-show="this.level >= 1" class="alert alert-danger header-tab" 
            v-bind:style="{ 'background-color': customizeData.ColorHex, 'color': customizeData.HeadColor }">
              {{ this.customizeData.HeadBranch }}
          </div>
        </transition>
        <transition name="fade">
          <div id="2" @click="tabClicked" v-show="this.level >= 2" class="alert alert-danger header-tab" 
            v-bind:style="{ 'background-color': customizeData.ColorHex, 'color': customizeData.HeadColor }">
              {{ this.customizeData.HeadEmployee }}
          </div>
        </transition>
        <transition name="fade">
          <div id="3" @click="tabClicked" v-show="this.level >= 3" class="alert alert-danger header-tab" 
            v-bind:style="{ 'background-color': customizeData.ColorHex, 'color': customizeData.HeadColor }">
              {{ this.customizeData.HeadAppt }}
          </div>
        </transition>
        <transition name="fade">
          <div id="4" @click="tabClicked" v-show="this.level >= 4" class="alert alert-danger header-tab" 
            v-bind:style="{ 'background-color': customizeData.ColorHex, 'color': customizeData.HeadColor }">
              {{ this.customizeData.HeadContact }}
          </div>
        </transition>
        <transition name="fade">
          <div v-show="this.level >= 5" class="alert alert-danger header-tab" v-bind:style="{ 'background-color': customizeData.ColorHex }">
              {{ this.customizeData.HeadSummary }}
          </div>
        </transition>
      
      <div v-show="this.level == 0" id="subheader11" class="subheader-tab" v-html="this.customizeData.SubHeadService">
      </div>
      <div v-show="this.level == 1" id="subheader11" class="subheader-tab" v-html="this.customizeData.SubHeadBranch">
      </div>
      <div v-show="this.level == 2" id="subheader11" class="subheader-tab" v-html="this.customizeData.SubHeadEmployee">
      </div>
      <div v-show="this.level == 3" id="subheader11" class="subheader-tab" v-html="this.customizeData.SubHeadAppt">
      </div>
      <div v-show="this.level == 4" id="subheader11" class="subheader-tab" v-html="this.customizeData.SubHeadContact">
      </div>
      <div v-show="this.level == 5" id="subheader11" class="subheader-tab" v-html="this.customizeData.SubHeadSummary">
      </div>

      <!-- ACTIVITY SELECT  -->
      <div v-show="this.level == 0" id="appoinemtencontent" class="content-div">
        <button 
          class="list-group-item btn-outline-light activity-button"
          v-bind:id="activity.ActivityID"
          @click="activityButtonTapped"
          v-for="activity in this.activities"
          v-bind:key="activity.ActivityID">
            <b-img left src="https://lorempixel.com/125/125/technics/8/" alt="left image" style="height:70px; width: auto; margin-top: -15px; margin-bottom: -15px; " />
            <span>{{ activity.TestName }} ({{ activity.Duration }}min)</span>
            <br>
            <span class="activity-description">Beschreibung</span>
        </button>
      </div>

      <!-- BRANCH SELECT  -->
      <div v-show="this.level == 1" id="branchselectcontent" class="content-div">
        <button 
          class="list-group-item btn-outline-light branch-button"
          v-bind:id="branch.BranchID"
          @click="branchButtonTapped"
          v-for="branch in this.branches"
          v-bind:key="branch.BranchID">
            {{ branch.BranchName }}
        </button>
      </div>

      <!-- PERSON SELECT  -->
      <div v-show="this.level == 2" id="personselectcontent" class="content-div">
        <button 

          class="list-group-item btn-outline-light activity-button"
          v-bind:id="person.EmployeeID"
          @click="personButtonTapped"
          v-for="person in this.filteredEmployees"
          v-bind:key="person.EmployeeID">
            <b-img @error="imageErrorLoad" left v-bind:src="'/OTeV/userdata/images/' + companyID + '/' + person.PictureName + '.jpg'" alt="Img" style="height:70px; width: auto; margin-top: -15px; margin-bottom: -15px; border:1px solid #e3e3e3; border-radius: 5px;" />
            {{ person.Name }}<br> <span class="activity-description">{{ person.Description || "-" }}</span>
        </button>
      </div>

      <!-- DATE SELECT  -->
      <div v-show="this.level == 3" id="dateselectcontent" class="content-div">
        <div class="input-group with-addon-icon-left" style="position:relative" >
							<Datepicker 
                v-if="this.selectedDate"
                :language="this.language"
                :disabled="datePickerState.disabled"
                format="dd.MM.yyyy"
                :value="this.selectedDate" 
                :monday-first="true" 
                placeholder="Datum wählen" 
                @selected="dateSelected" 
                wrapper-class="datepicker-wrapper" 
                input-class="datepicker-input"></Datepicker>
        </div>
        <TimeViewComponent v-bind:EmployeeAv="this.EmployeeAv" 
          v-bind:RoomAv="this.RoomAv" 
          v-bind:ErrorMessage="this.customizeData.ErrorMessage"
          v-bind:SlotPitch="this.customizeData.SlotPitch"
          v-bind:Activity="this.selectedActivity"
          v-bind:DayOffset="this.customizeData.dayOffset"
          v-bind:SelectedDate="this.selectedDate" 
          v-bind:HexColor="this.customizeData.ColorHex"
          @timeClick="timeItemClicked"></TimeViewComponent>
      </div>

      <!-- INFO INPUT  -->
      <div v-show="this.level == 4" id="infoselectcontent" class="content-div">
        <form name="frm1" style=" margin-top:opx; margin-left:2%; margin-right:2%; width:96% ;padding:2%; height:100%">
              <b-alert :show="!this.formInputValid && this.summaryButtonWasTapped">{{ this.InputErrorMsg }}</b-alert>
							<b-form-radio-group id="radios2" v-model="userData.Sex" name="radioSubComponent">
                <b-form-radio value="false">Herr</b-form-radio>
                <b-form-radio value="true">Frau</b-form-radio>
              </b-form-radio-group>
              <br>
							<div class="col-12"  style="margin-bottom: 20px" >
								 <div class="input-group">
									<span class="input-group-addon">
										<i id="glyph1" class="fa fa-users fa-fw" style="color:#0061AD"></i>
									</span>
									<input v-model="userData.Name" id="name" class="form-control" type="text" name="name" placeholder="Nachname*" >
								</div>
							</div>
							
							
							<div class="col-12" style="margin-bottom: 20px">
								<div class="input-group">
									<span class="input-group-addon">
										<i id="glyph2" class="fa fa-user fa-fw" style="color:#0061AD"></i>
									</span>
									<input v-model="userData.Vorname" id="vorname" class="form-control" type="text" name="vorname"  placeholder="Vorname*" >
								</div>	
							</div>
							
							<div class="col-12" style="margin-bottom: 20px; ">
								<div class="input-group">
									<span class="input-group-addon">
										<i class="fa fa-mobile fa-fw"></i>
									</span>
									<input v-model="userData.Phone" class="form-control" type="text" id="mobile" name="mobile" placeholder="Mobilnummer">
								</div>	
							</div>
							
							<div class="col-12" style="margin-bottom:30px; ">
								<div class="input-group">
									<span class="input-group-addon">
										<i id="glyph3" class="fa fa-envelope-o fa-fw" style="color:#0061AD"></i>
									</span>
									<input v-model="userData.Email" class="form-control" type="text" id="email"  name="email" placeholder="E-Mail*" >
								</div>	
							</div>
							
							<div class="col-12" style="margin-bottom: 20px; ">
								<div class="input-group">
									
								<textarea style="height: 200px; border: 1px solid #ced4da;" v-model="userData.Remarks" class="form-control" cols="40" rows="4" id="remarks" name="remarks" placeholder="Bermerkung"></textarea>
								</div>	
							</div>
						
							<button v-bind:style="{ background: this.customizeData.ColorHex }" 
                id="summery-button" type="button" class="btn btn-outline-light" 
                @click="summaryButtonClicked"
                style=" margin-top:30px; width: 150px;">{{this.customizeData.ButtonSum}}</button>
							
						</form>
      </div>

      <!-- SUMMARY  -->
      <div v-show="this.level == 5" id="Summaryselectcontent" class="content-div">
				
				<div  id="mapsinframe" style="background-color:white; padding:2%; font-size: 1em;font-family: Poppins; color:#0061AD; text-align:center;border-radius: 0px 0px 15px 15px;">
          
          <div style="text-align: center; color: #000;" v-show="!this.sendButtonWasTapped">
          <p style="font-weight: 700;">{{ this.selectedActivity.TestName }} ({{ this.selectedActivity.Duration }}min)<br>
          {{ this.userData.Date }}</p>
          <p>{{ this.userData.Vorname }} {{ this.userData.Name }}
          <br>{{this.userData.Email || "-" }} </p>
          
          <button v-bind:style="{ background: this.customizeData.ColorHex }" 
                id="summery-button" type="button" class="btn btn-outline-light" 
                @click="sendButtonTapped"
                style=" margin-top:30px; width: 150px;">{{this.customizeData.ButtonSend}}</button>
          <br>
          <b-progress v-show="this.requestSending" style="margin-top: 25px;" :value="100" variant="success" striped class="mb-2"></b-progress>
          <br>
          <hr>
          </div>

          <div v-show="this.sendButtonWasTapped">
            
            <p v-bind:style="{ color: customizeData.ColorHex }" id="IframHeader">{{ this.customizeData.IframHeader }}<p>
            <iframe style="width: 100%;" id="iframe" v-bind:src="this.customizeData.IframURL"></iframe>
            <p v-bind:style="{ color: customizeData.ColorHex }" id="IframFooter" style="font-size: 1.5em;font-weight:500">{{ this.customizeData.IframFooter }}<p>
        
            
            <div style="opacity: 1; width:96%; margin-left:2%; margin-bottom:20px; font-family: Poppins;font-size: 1.2em;text-align:center; ">
            
            <img  id="Img5" v-bind:src="'/OTeV/userdata/images/' + this.companyID + '/' + this.companyID + '-' + this.userData.BranchID + '-Logo.jpg'"  height="40%" width="80% " style="max-width:500px; max-height:150px"> 
            
            </div>	
          </div>
					
				
				</div>
      </div>
      <hr v-if="this.userData.BranchID">
      <div style="opacity: 1; width:96%; margin-left:2%; margin-bottom:20px; color:#0061AD; font-family: Poppins;font-size: 1.2em;text-align:center; ">
        <img width="150" id="footer-logo" 
          v-bind:src="'/OTeV/userdata/images/' + this.companyID + '/' + this.companyID + '-' 
            + this.userData.BranchID + '-Logo.jpg'"
          v-if="this.userData.BranchID"> 
      </div>		
    </div>
    <div class="col-xs-zero col-xl-4">
    </div>		
  </div>
  


</div>
</template>


<script>
import Datepicker from "vuejs-datepicker";
import TimeViewComponent from "@/components/TimeViewComponent";

export default {
  name: "MainView",
  components: {
    Datepicker,
    TimeViewComponent: TimeViewComponent
  },
  props: {
    companyID: {
      default: "-1",
      type: String
    },
    selectedDate: {
      default: function() {
        return new Date();
      },
      type: Date
    },
    customizeData: {
      default: function() {
        return {};
      },
      type: Object
    },
    userData: {
      default: function() {
        return {};
      },
      type: Object
    }
  },
  data() {
    return {
      activities: [],
      language: navigator.language.split("-")[0],
      disabledDate: new Date(),
      branches: [],
      employees: [],
      filteredEmployees: [],
      EmployeeAv: [],
      RoomAv: [],
      selectedActivity: {},
      selectedEmployee: {},
      selectedBranch: {},
      level: 0,
      formInputValid: false,
      sendButtonWasTapped: false,
      summaryButtonWasTapped: false,
      requestSending: false,
      noAccessURL: process.env.NOACCESSURL,
      rootURL: "D:\\InetPub\\WWWRoot\\",
      datePickerState: {
        disabled: 
        {
          to: this.disabledDate,
          days: [0]
        }
      },
      InputErrorMsg: ""
    };
  },
  methods: {
    onLoad: function() {

      var dat = new Date();
      dat.setDate(dat.getDate() + parseInt(this.customizeData.dayOffset.replace("+", "").replace("d", "")));
      this.disabledDate = dat;

      this.datePickerState.disabled.to = this.disabledDate;

      console.log("LANGUAGE: " + this.language);
      this.userData.Vorname = "";

      this.$http
        .get(
            this.noAccessURL + "getAppointment.php?action=activities&companyId=" +
            this.companyID
        )
        .then(
          response => {
            this.activities = response.body;
          },
          response => {
            // error callback
          }
        );

      this.$http
        .get(
          this.noAccessURL + "getAppointment.php?action=branches&companyId=" +
            this.companyID
        )
        .then(
          response => {
            this.branches = response.body;
            console.log(this.branches);
          },
          response => {
            // error callback
          }
        );
    },
    imageErrorLoad: function(err)
    {
      err.target.style.display = 'none';
    },
    validateFormInputs : function ()
    {
      if(!this.userData.Name)
      {
        this.InputErrorMsg = "Bitte geben Sie einen Namen ein";
        return false;
      }
      if(!this.userData.Vorname)
      {
        this.InputErrorMsg = "Bitte geben Sie einen Vornamen ein";
        return false;
      }
      if(!this.userData.Sex)
      {
        this.InputErrorMsg = "Bitte geben Sie eine Anrede ein";
        return false;
      }
      if(!this.userData.Email)
      {
        this.InputErrorMsg = "Bitte geben Sie eine Email ein";
        return false;
      }
      if(!this.userData.Phone)
      {
        this.userData.Phone = '';
      }
      if(!this.userData.Remarks)
      {
        this.userData.Remarks = '';
      }

      return true;
    },
    activityButtonTapped: function(e) {
      var aId = e.target.id;
      this.userData.ActivityID = aId;
      this.userData.CompanyID = this.companyID;

      this.activities.forEach(element => {
        if (element.ActivityID == aId) {
          this.selectedActivity = element;
        }
      });



      this.level++;
    },
    branchButtonTapped: function(e) {
      var bId = e.target.id;
      this.userData.BranchID = bId;
      

      this.filteredEmployees = [];

      this.$http
        .get(
          this.noAccessURL + "getAppointment.php?action=employeeActivites&companyId=" +
            this.companyID + "&activityId=" + this.userData.ActivityID
        )
        .then(
          response => 
          {
            this.employees = response.body;
            var b = {};
            b.EmployeeID = 0;
            b.ActivityID = this.userData.ActivityID;
            b.Name = "Belieber Mitarbeiter";
            b.PictureName = this.userData.CompanyID + "-0-team.jpg";
            b.Description = "Wird automatisch zugewiesen";

            this.filteredEmployees.push(b);

            this.employees.forEach(element => 
            {
              console.log(JSON.stringify(element));
              if (element.ActivityID == this.userData.ActivityID) 
              {
                  this.filteredEmployees.push(element);
              }
            });

            this.level++;
          },
          response => {
            // error callback
          }
      );


    },
    personButtonTapped: function(e) {
      var pId = e.target.id;
      this.userData.EmployeeID = pId;

      var dat = this.disabledDate;
      dat.setDate(dat.getDate() + 1);

      this.dateSelected(dat);
      this.level++;
    },
    dateSelected: function(d) 
    {
      this.selectedDate = d;
      var formData = new FormData();

      formData.append("EmployeeID", this.userData.EmployeeID);
      formData.append("ActivityID", this.userData.ActivityID);
      formData.append("SelectetCompanyID", this.userData.CompanyID);
      formData.append("BranchID", this.userData.BranchID);
      formData.append("Selectetdate", d);

      this.$http.post(this.noAccessURL + "call.php", formData).then(
        response => {
          this.EmployeeAv = response.body[0];
          this.RoomAv = response.body[1];
        },
        response => {
          // error callback
        }
      );
    },
    timeItemClicked: function(e) 
    {
      this.userData.RoomID = e.RoomID;
      this.userData.Date = e.Date;
      this.userData.assignEmployeeID = e.EmployeeID;
      this.level++;
    },
    summaryButtonClicked: function() 
    {
      this.summaryButtonWasTapped = true;
      this.formInputValid = this.validateFormInputs();
      if(this.formInputValid)
        this.level++;
    },
    sendButtonTapped: function() 
    {
      this.requestSending = true;
      this.formInputValid = this.validateFormInputs();
      if(this.formInputValid)
      {
      
        var formData = new FormData();
        formData.append("CompanyID", this.companyID);
        formData.append("BranchID", this.userData.BranchID);
        formData.append("LastName", this.userData.Name);
        formData.append("FirstName", this.userData.Vorname);
        formData.append("Sex", this.userData.Sex);
        formData.append("Email", this.userData.Email);
        formData.append("Mobile", this.userData.Phone);
        formData.append("ActivitySelected", this.userData.ActivityID);
        formData.append("EmployeeSelected", this.userData.EmployeeID);
        formData.append("EmployeeAssigned", this.userData.EmployeeID);
        formData.append("RoomAssigned", this.userData.RoomID);
        formData.append("AppStart", this.userData.Date);
        formData.append("AppEnd", this.userData.Date);
        formData.append("SubmitTime", this.$moment());
        formData.append("Duration", this.selectedActivity.Duration);

        this.$http.post(this.noAccessURL + "submit.php", formData).then(
          response => {
            this.sendButtonWasTapped = true;
            this.requestSending = false;
            console.log(response.body);
            
          },
          response => {
            // error callback
          }
        );
      }
    },
    tabClicked: function (e)
    {
      var id = e.target.id;

      this.level = id;

    }
  },
  beforeMount() {

    var otevurl = this.$route.params.otevurl;


    if (this.companyID == "-1") 
    {
      if(otevurl)
      {
        this.$http.get(this.noAccessURL + 'otevurl.php?otevurl=' + otevurl).then(response => {
          this.companyID = response.body.CompanyID;
          console.log("CONPANYID: " + this.companyID);
          if(this.companyID != "-1")
          {
            this.$http.get(this.noAccessURL + 'getAppointment.php?action=personalize&companyId=' + this.companyID).then(response => {
              this.customizeData = response.body[0];
              this.onLoad();
              return;
            }, response => 
            {
              console.log("ERROR: " + response);
            });
            
          }
        }, response => 
        {
          this.$router.push({ path: "/" }); 
          return;
        });
      }
      else
      { 
        this.$router.push({ path: "/" }); 
        return;
      }
      
    }
    else
    {
      console.log("fhfh");
      this.onLoad();
    }

    
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins");

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}


h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#LandingText {
  text-align: left;
  margin-left: 15px;
}

#LandingMessage {
  text-align: left;
}

.first-header-tab {
  text-align: center;
  font-family: Poppins;
  font-size: 1.2em;
  font-weight: 500;
  color: white;
  padding: 0.4rem;
  border-radius: 15px 15px 0px 0px;
  border: 0;
  margin-bottom: 0;
  border-bottom: 1px solid #929292;
  cursor: pointer;
}

.header-tab {
  text-align: center;
  font-family: Poppins;
  font-size: 1.2em;
  font-weight: 500;
  color: white;
  padding: 0.4rem;
  border-radius: 0px 0px 0px 0px;
  border: 0;
  margin-bottom: 0;
  border-bottom: 1px solid #929292;
  cursor: pointer;
}

.subheader-tab {
  width: 96%;
  margin-left: 2%;
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 1.2em;
  text-align: center;
}

.content-div {
  background-color: white;
  padding: 2%;
  font-size: 0.8em;
  font-family: Poppins;
  margin-bottom: 10px;
  text-align: center;
}

.activity-button {
  margin-left: 3%;
  margin-right: 3%;
  width: 94%;
  padding: 0;
  padding-top: 15px;
  padding-bottom: 15px;
  color: #000;
  cursor: pointer;
}

.branch-button {
  margin-left: 3%;
  margin-right: 3%;
  width: 94%;
  padding: 0.75em, 1.25rem;
  color: #000;
  cursor: pointer;
}

.activity-description {
  font-size: 0.8em;
  font-family: Poppins;
  color: #929292;
}

.activity-button:hover {
  box-shadow: 0 0 5px #e3e3e3;
}

.footer-logo {
  max-width: 500px;
  max-height: 150px;
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/MainView.vue